import { EmptyArray } from "../domain/empty/model";
import { DocumentsRepositoryImplementation } from '../infrastructure/documents-repository-implementation'


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new DocumentsRepositoryImplementation()

const CACHE_PREFIX = 'documents';

//NEW

async function getElectronicDocumentsSettings(uid: string, cid: string | null) {
    const cacheKey = `${CACHE_PREFIX}-settings-${uid}-${cid}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) return cached;

    const response = await repo.getElectronicDocumentsSettings(uid, cid).toPromise()
    if (response.success) {
        const data = response.data;
        if (data.length === 0) return EmptyArray;

        cacheManager.setItem(cacheKey, data);
        return data;
    } else {
        throw response.error
    }
}

async function addResolution(uid: string, cid: string | null, payload: unknown) {
    const response = await repo.addResolution(uid, cid, payload).toPromise()
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data
}

async function toggleEnableSettings(uid: string, cid: string | null, id: number, enable: boolean) {
    const response = await repo.toggleEnableSettings(uid, cid, id, enable).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

async function updateResolution(uid: string, cid: string | null, id: number, payload: unknown) {
    const response = await repo.updateResolution(uid, cid, id, payload).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

async function emitSupportDocument(uid: string, cid: string | null, documentId: number, documentType: 'spend' | 'buy', notes?: string) {
    const response = await repo.emitSupportDocument(uid, cid, {
        document_id: documentId,
        document_type: documentType,
        notes,
    }).toPromise();
    return response?.data ?? response;
}

async function cancelSupportDocument(prefix: string, number: number | string, uid = '', cid: string | null = null) {
    const response = await repo.cancelSupportDocument(uid, cid, prefix, number).toPromise();
    return response?.data ?? response;
}

async function getSupportDocuments(
    uidOrParams?: any,
    cid?: string | null,
    page = 1,
    limit = 10,
    filters?: {
        status?: string;
        model?: string;
        date_from?: string;
        date_to?: string;
        search?: string;
    }
) {
    let uid = '';
    let companyId = null;
    let p = 1;
    let l = 10;
    let f = filters || {};

    if (typeof uidOrParams === 'object' && uidOrParams !== null) {
        p = uidOrParams.page || 1;
        l = uidOrParams.limit || 10;
        uid = uidOrParams.uid || '';
        companyId = uidOrParams.cid ?? null;
        f = {
            status: uidOrParams.status,
            model: uidOrParams.model,
            date_from: uidOrParams.date_from,
            date_to: uidOrParams.date_to,
            search: uidOrParams.search,
        };
    } else {
        uid = uidOrParams || '';
        companyId = cid ?? null;
        p = page || 1;
        l = limit || 10;
    }

    const response = await repo.getSupportDocuments(
        uid,
        companyId,
        p,
        l,
        f.status,
        f.model,
        f.date_from,
        f.date_to,
        f.search
    ).toPromise();
    return response?.data ?? response;
}


//OLD

async function getInvoices(uid: string, cid: string | null, page: number, limit: number, force = false, status?: string, date_from?: string, date_to?: string, origin?: string) {
    // Si hay filtros activos no cachear — demasiadas combinaciones posibles
    const hasFilters = !!(status || date_from || date_to || origin);
    const cacheKey = `${CACHE_PREFIX}-invoices-${page}-${limit}-${origin || 'all'}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached && !force && !hasFilters) return cached;

    const response = await repo.getAllInvoices(uid, cid, page, limit, status, date_from, date_to, origin).toPromise()
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    if (!hasFilters) cacheManager.setItem(cacheKey, data);
    return data;
}

async function getConflictedSales(uid: string, cid: string | null, page: number, limit: number, force = false, origin?: string) {
    const cacheKey = `${CACHE_PREFIX}-conflicted-sales-${page}-${limit}-${origin || 'all'}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached && !force && !origin) return cached;

    const response = await repo.getConflictedSales(uid, cid, page, limit, origin).toPromise();
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    if (!origin) cacheManager.setItem(cacheKey, data);
    return data;
}

async function resolveConflict(uid: string, cid: string | null, bill_id: number, force_generate: boolean) {
    const response = await repo.resolveConflict(uid, cid, bill_id, force_generate).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response;
}



async function getResolutions(uid: string, cid: string | null) {
    const cacheKey = `${CACHE_PREFIX}-resolutions`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) {
        console.log(`Returning resolutions for ${uid}/${cid} from cache`);
        return cached;
    }
    const response = await repo.getInvoiceResolutions(uid, cid).toPromise()
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
}

async function getCreditNotes(uid: string, cid: string | null, page: number, limit: number) {
    const cacheKey = `${CACHE_PREFIX}-credit_notes-${page}-${limit}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) return cached;

    const response = await repo.getAllCreditNotes(uid, cid, page, limit).toPromise()
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
}

async function createCreditNote(prefix: string, invoiceNumber: number) {
    const response = await repo.createCreditNote(prefix, invoiceNumber).toPromise()
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data
}

async function getInvoicesByNumber(uid: string, cid: string | null, prefix: string, invoiceNumber: number) {
    const cacheKey = `${CACHE_PREFIX}-invoiceByNumber-${prefix}-${invoiceNumber}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) {
        console.log(`Returning invoice ${prefix}-${invoiceNumber} for ${uid}/${cid} from cache`);
        return cached;
    }

    const response = await repo.getInvoiceByNumber(uid, cid, invoiceNumber, prefix).toPromise()
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
}

async function getInvoicePDF(uid: string, cid: string, cude: string) {
    const response = await repo.getInvoicePDF(uid, cid, cude).toPromise()
    return response.data
}

async function redirectToInvoice(id: number) {
    const response = await repo.redirectToInvoice(id).toPromise();
    const cufeString = response.cufe;
    const cufeMatch = cufeString.match(/CUFE: ([a-fA-F0-9]+)/);
    if (cufeMatch && cufeMatch[1]) {
        return cufeMatch[1].replace("NumFac: ", "");
    }
    return null;
}


async function detectInvoicingGaps(uid: string, cid: string | null, prefix?: string, page = 1, limit = 6) {
    const response = await repo.detectInvoicingGaps(uid, cid, prefix, page, limit).toPromise();
    return response?.data ?? response;
}

async function linkGapInvoice(uid: string, cid: string | null, prefix: string, number: number) {
    const response = await repo.linkGapInvoice(uid, cid, prefix, number).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response?.data ?? response;
}

async function discardGapInvoice(uid: string, cid: string | null, prefix: string, number: number) {
    const response = await repo.discardGapInvoice(uid, cid, prefix, number).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response?.data ?? response;
}

async function cancelGapWithCreditNote(uid: string, cid: string | null, prefix: string, number: number, discrepancy_code = 2, notes = "Anulación de factura huérfana / auditoría") {
    const response = await repo.cancelGapWithCreditNote(uid, cid, prefix, number, discrepancy_code, notes).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response?.data ?? response;
}

async function voidGapConsecutive(uid: string, cid: string | null, prefix: string, number: number, reason = "Consecutivo no utilizado / anulado internamente") {
    const response = await repo.voidGapConsecutive(uid, cid, prefix, number, reason).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response?.data ?? response;
}

export {
    getElectronicDocumentsSettings,
    addResolution,
    updateResolution,

    redirectToInvoice,

    getInvoices,
    getResolutions,
    getCreditNotes,
    createCreditNote,
    getInvoicesByNumber,
    getInvoicePDF,
    emitSupportDocument,
    getSupportDocuments,
    cancelSupportDocument,
    toggleEnableSettings,
    getConflictedSales,
    resolveConflict,
    detectInvoicingGaps,
    linkGapInvoice,
    discardGapInvoice,
    cancelGapWithCreditNote,
    voidGapConsecutive
}
